import React from 'react'
import Button from 'react-bootstrap/Button';
// import Spinner from 'react-bootstrap';

export const SubmitButton = (props) => {
  return (
    <Button
      label={props.label}
      type='submit'
      className={'btn-fill pull-right '+props.className}
      disabled={props.disabled ? true : false}
      variant="info"
    >{props.label}</Button>
  )
}
